module.exports = __webpack_public_path__ + "static/media/iconFont.c5d2247a.svg";